// src/VerifyEmailPage.jsx
import React, { useState } from "react";
import { Box, Typography, Button, Alert } from "@mui/material";

const VerifyEmailPage = () => {
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [sending, setSending] = useState(false);

  const handleClick = async () => {
    setInfo(null);
    setError(null);
    setSending(true);

    try {
      const client = window.$memberstackDom; // auth client injected by the script

      if (!client || typeof client.sendMemberVerificationEmail !== "function") {
        throw new Error("Email client is not available");
      }

      await client.sendMemberVerificationEmail();

      setInfo(
        "Verification email has been resent. " +
          "If you don’t see it in a few minutes, check your spam or promotions folder."
      );
    } catch (err) {
      console.error("Failed to resend verification email", err);
      setError(
        "Couldn’t resend the verification email. Please try again in a minute."
      );
    } finally {
      setSending(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        bgcolor: "#f5f5f5",
      }}
    >
      <Box
        sx={{
          maxWidth: 480,
          width: "100%",
          bgcolor: "white",
          borderRadius: 2,
          boxShadow: 3,
          p: 4,
          textAlign: "center",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Verify your email
        </Typography>

        <Typography variant="body1" sx={{ mb: 2 }}>
          We&apos;ve sent a verification link to your email address.
          <br />
          Please click the link in that email to continue.
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          If you don&apos;t see it, check your spam or promotions folder.
        </Typography>

        {info && (
          <Alert severity="info" sx={{ mb: 2, textAlign: "left" }}>
            {info}
          </Alert>
        )}

        {error && (
          <Alert severity="error" sx={{ mb: 2, textAlign: "left" }}>
            {error}
          </Alert>
        )}

        <Button
          variant="contained"
          sx={{ borderRadius: "999px" }}
          onClick={handleClick}
          disabled={sending}
        >
          {sending ? "Sending..." : "Resend verification email"}
        </Button>

        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mt: 2, display: "block" }}
        >
          You can close this tab and come back after you&apos;ve clicked the link.
        </Typography>
      </Box>
    </Box>
  );
};

export default VerifyEmailPage;